<template>
  <div class="cmg-gh">
    <section class="cmg-gh-bg" id="cmg-gh">
      <div class="container">
        <div class="row">
          <div class="cmg-greenhouse-container">
            <h2>Join the team</h2>
            <div
              v-html="options.cmg_greenhouse_shortcode"
              v-if="enableCmgGreenhouse && optionsReady"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { scroller } from "vue-scrollto/src/scrollTo";

export default {
  props: ["blockdata"],
  name: "block-cmg-greenhouse",
  data() {
    return {
      options: null,
      optionsReady: false,
      enableCmgGreenhouse: this.blockdata.enable_cmg_greenhouse,
    };
  },
  mounted: function () {
    this.fetchData();

    if (this.$route.hash === "#cmg-gh") {
      const firstScrollTo = scroller();
      firstScrollTo("#cmg-gh");
    }
  },
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/acf/v3/options/options",
        function (response) {
          self.options = response.acf;
          self.optionsReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// BlockCmgGreenhouse.vue?667ee10d